
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 py-10 border-t">
      <div className="max-w-4xl mx-auto px-6 text-[12px] text-gray-400 leading-relaxed">
        <p>(주)아이언팩토리는 통신판매의 당사자가 아니며, 상품·거래 정보 및 거래에 관한 책임은 판매자에게 있습니다.</p>
        <br />
        <div>
          <span className="font-semibold text-gray-600 block mb-1">아이언팩토리 제휴문의 : 010-4262-6293</span>
          <span className="font-semibold text-gray-600 block">(주) 아이언팩토리 대표자 : 김종혁</span>
        </div>
        <div className="my-4 flex items-center space-x-3">
          <a href="#" className="hover:underline">사업자 정보</a>
          <a href="#" className="hover:underline">개인정보 처리방침</a>
          <a href="#" className="hover:underline">서비스 이용약관</a>
        </div>
        <p>Copyright © 2024 아이언팩토리 All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
